import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { CarBarrierIcon } from '@repo/icons';
/** The round marker of the parking entrance on the map; brand-2 when its parking is selected. */
export default function ParkingEntranceMarkerIcon({ isSelected = false }) {
    return (_jsx("div", { className: classNames('flex h-9 w-9 items-center justify-center rounded-full border-2 border-white text-white shadow-md', isSelected ? 'bg-brand-2' : 'bg-brand'), children: _jsx(CarBarrierIcon, { size: 20 }) }));
}
